import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { ErrorAlertModule } from '@/store/modules/errors';
import {
  CheckMrpaFilePayload,
  CheckMrpaGuidPayload,
  checkMrpaSubjectGuid,
  checkMrpaSubjectFile,
  checkMrpaParticipantFile,
  checkMrpaParticipantGuid, checkMrpaSubjectFileMultiple, checkMrpaSubjectGuidMultiple
} from '@/api/statements';
import { ISubject } from '@/types/services';
import { errorHandler } from "@/utils/common";

export interface IMrpaSubjectState {
  entity: ISubject | null;
  entityMultiple: ISubject[] | null;
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

@Module({ dynamic: true, store, name: 'mrpaSubject', namespaced: true })
class MrpaSubject extends VuexModule implements IMrpaSubjectState {
  public entity: ISubject | null = null;
  public entityMultiple: ISubject[] | null = null;
  public loaded = false;
  public loading = false;
  public error = false;


  @Mutation
  private setMrpaSubject(item: ISubject) {
    this.entity = item;
  }

  @Mutation
  private checkPending() {
    ErrorAlertModule.setErrorAlert('');
    this.entity = null;
    this.loading = true;
    this.loaded = false;
    this.error = false;
  }

  @Mutation
  private checkFulfilled(data: ISubject) {
    this.entityMultiple = null;
    this.entity = data;
    this.loading = false;
    this.loaded = true;
  }

  @Mutation
  private checkFulfilledMultiple(data: ISubject[]) {
    this.entityMultiple = data;
    this.entity = null;
    this.loading = false;
    this.loaded = true;
  }

  @Mutation
  private checkRejected(error: unknown) {
    errorHandler(error)
    this.loading = false;
    this.error = true;
  }

  @Action
  public async checkMrpaSubjectFile(payload: CheckMrpaFilePayload) {
    this.checkPending();

    try {
      const data = await checkMrpaSubjectFile(payload);
      this.checkFulfilled(data);
    } catch (error) {
      this.checkRejected(error);

      throw error;
    }
  }

  @Action
  public async checkMrpaSubjectFileMultiple(payload: CheckMrpaFilePayload) {
    this.checkPending();

    try {
      const data = await checkMrpaSubjectFileMultiple(payload);
      if (data.length === 1) {
        this.checkFulfilled(data[0]);
      } else {
        this.checkFulfilledMultiple(data);
      }
    } catch (error) {
      this.checkRejected(error);

      throw error;
    }
  }

  @Action
  public async checkMrpaSubjectGuid(payload: CheckMrpaGuidPayload) {
    this.checkPending();

    try {
      const data = await checkMrpaSubjectGuid(payload);
      this.checkFulfilled(data);
    } catch (error) {
      this.checkRejected(error);

      throw error;
    }
  }

  @Action
  public async checkMrpaSubjectGuidMultiple(payload: CheckMrpaGuidPayload) {
    this.checkPending();

    try {
      const data = await checkMrpaSubjectGuidMultiple(payload);
      if (data.length === 1) {
        this.checkFulfilled(data[0]);
      } else {
        this.checkFulfilledMultiple(data);
      }
    } catch (error) {
      this.checkRejected(error);

      throw error;
    }
  }

  @Action
  public async checkMrpaParticipantFile(payload: CheckMrpaFilePayload) {
    this.checkPending();

    try {
      const data = await checkMrpaParticipantFile(payload);
      this.checkFulfilled(data);
    } catch (error) {
      this.checkRejected(error);

      throw error;
    }
  }

  @Action
  public async checkMrpaParticipantGuid(payload: CheckMrpaGuidPayload) {
    this.checkPending();

    try {
      const data = await checkMrpaParticipantGuid(payload);
      this.checkFulfilled(data);
    } catch (error) {
      this.checkRejected(error);

      throw error;
    }
  }
}

export const MrpaSubjectModule = getModule(MrpaSubject);
